import React from "react";
import { Box, Typography, Grid, Paper, Container } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import PeopleIcon from "@mui/icons-material/People";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ViewQuiltIcon from "@mui/icons-material/ViewQuilt";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AssessmentIcon from "@mui/icons-material/Assessment";

const features = [
    { text: "Data-driven Digital Marketing Services", icon: <BusinessIcon /> },
    { text: "Industry Experts", icon: <PeopleIcon /> },
    { text: "Custom Digital Marketing Framework", icon: <DashboardIcon /> },
    { text: "Omnichannel Personalization", icon: <ViewQuiltIcon /> },
    { text: "Competitive Pricing", icon: <AttachMoneyIcon /> },
    { text: "Campaign Monitoring and Evaluation", icon: <AssessmentIcon /> },
];

const BoostBusinessSection = () => {
    return (
        <Box sx={{ textAlign: "center", paddingBottom:"40px", 
        // backgroundColor: "#000", 
        color: "white" }}>
            <Container>
                <Typography sx={{ color: "#DADFEF", marginBottom: "25px",fontSize:"25px" }}  fontWeight={600} gutterBottom>
                    Boost Your Business
                </Typography>
                <Typography  maxWidth="md" mx="auto" mb={3} sx={{ color: "#fff",fontSize:"18px" }}>
                    We specialize in targeted advertising solutions that boost client retention and optimize conversions.
                    By understanding each client's unique needs, we tailor our strategies for maximum engagement.
                    Using advanced analytics and innovative marketing techniques, we help businesses attract new
                    customers and keep their existing ones returning.
                </Typography>
                <Grid container spacing={2} justifyContent="center">
                    {features.map((industry, index) => (
                        <Grid item xs={12} sm={6} md={6} key={index}>
                            <Paper
                                elevation={3}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    padding: 2,
                                    borderRadius: 2,
                                    backgroundColor: "transparent",
                                    color: "#B6BFE080",
                                    cursor: "pointer",
                                    borderColor: "linear-gradient(to right, #BEBFF4, #2D30AB)",
                                    border: "3px solid",
                                    '&:hover': { backgroundColor: "#C64BCE" }
                                }}
                            >
                                {industry.icon}
                                <Typography style={{ color: "white" }}>{industry.text}</Typography>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default BoostBusinessSection;
